export const NibssVerificationRoutes = {
	Start: '',
	Redirect: 'redirect',
	FailedVerificationModal: 'redirect/failed-verification',
	SuccessfulVerificationModal: 'redirect/successful-verification',
};

const BasePath = '/nibss-bvn-verification';
export const NibssVerificationPaths = {
	Start: `/${BasePath}`,
	Redirect: `/${BasePath}/${NibssVerificationRoutes.Redirect}`,
	FailedVerificationModal: `/${BasePath}/${NibssVerificationRoutes.FailedVerificationModal}`,
	SuccessfulVerificationModal: `/${BasePath}/${NibssVerificationRoutes.SuccessfulVerificationModal}`,
};
